<template>
  <transition name="fade">
    <div
      v-if="show"
      class="
        fixed
        inset-0
        z-50
        flex
        items-center
        justify-center
        bg-black bg-opacity-50
        p-4
      "
      @click.self="close"
    >
      <div
        class="
          bg-white
          rounded-lg
          shadow-xl
          w-full
          max-w-3xl
          flex flex-col
        "
        style="max-height: 90vh;"
      >
        <div
          class="
            px-6
            py-4
            border-b border-gray-200
            flex
            justify-between
            items-center
            bg-gray-50
            rounded-t-lg
          "
        >
          <h3 class="text-lg font-bold text-gray-800">{{ title }}</h3>
          <button
            @click="close"
            class="
              text-gray-500
              hover:text-red-500
              focus:outline-none
              transition-colors
            "
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>
        <div
          class="
            px-6
            py-4
            flex-1
            overflow-y-auto
            custom-html-content
            text-gray-700 text-left
          "
          v-html="content"
        ></div>
        <div
          class="
            px-6
            py-3
            border-t border-gray-200
            bg-gray-50
            text-right
            rounded-b-lg
          "
        >
          <button
            @click="close"
            class="
              px-4
              py-2
              bg-lime-600
              text-white
              rounded
              hover:bg-lime-700
              transition-colors
              font-medium
              text-sm
            "
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalText",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  watch: {
    show(val) {
      if (val) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
